import { formatDateForAPI } from "utils/utils";
import CalendarDatePicker from "ui/components/comp-507";
import UserCombobox from "components/directus/combobox/user";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "ui/components/select";

const ACKNOWLEDGEMENT_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Acknowledged", value: "true" },
  { label: "Not acknowledged", value: "false" },
];

function getAcknowledgementValue(filters) {
  if (filters?.is_logged?._eq === true) return "true";
  if (filters?.is_logged?._null === true) return "false";
  return "all";
}

export default function MyTeamAcknowledgementFilters({
  filters,
  setFilters,
}) {
  const handleAcknowledgementChange = (value) => {
    setFilters({
      ...filters,
      is_logged:
        value === "true"
          ? { _eq: true }
          : value === "false"
            ? { _null: true }
            : undefined,
    });
  };

  return (
    <div className="flex gap-2">
      <Select
        value={getAcknowledgementValue(filters)}
        onValueChange={handleAcknowledgementChange}
      >
        <SelectTrigger className="w-44">
          <SelectValue placeholder="Acknowledgement" />
        </SelectTrigger>
        <SelectContent>
          {ACKNOWLEDGEMENT_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <UserCombobox
        value={filters?.employee?._eq}
        onChange={(val) =>
          setFilters({ ...filters, employee: val ? { _eq: val } : undefined })
        }
        filter={{ user: { status: { _eq: "active" } } }}
        className="w-70"
        searchPlaceholder="Search employee..."
        hideLabel={true}
        clearable={true}
      />
      <CalendarDatePicker
        date={{
          from: filters?.date?._gte,
          to: filters?.date?._lte,
        }}
        setDate={(range) =>
          setFilters({
            ...filters,
            date: {
              _gte: range?.from ? formatDateForAPI(range.from) : undefined,
              _lte: range?.to ? formatDateForAPI(range.to) : undefined,
            },
          })
        }
      />
    </div>
  );
}
